import { RouteObject } from 'react-router-dom';
import { ROUTE_AUTH_MAGIC } from '@/constants/routes';
import AuthMagicPage from './auth-magic.page';

export const routeAuthMagic: RouteObject = {
  path: ROUTE_AUTH_MAGIC,
  Component: AuthMagicPage,
};
